module.exports = __webpack_public_path__ + "flyer_background_purple_disco_077-7de5a366ba881cc3e868d670203cd444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_purple_disco_077.jpg
// module id = 1681
// module chunks = 1